import React, { useEffect } from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { AccessTime, CheckCircle } from "@mui/icons-material";
import PendingIcon from "@mui/icons-material/Pending";
import FactoryIcon from '@mui/icons-material/Factory';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { prDashboardAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";

const ProductionDashboard = () => {
  const dispatch = useDispatch();
  const { successData } = useSelector((state) => state.prDashboardReducer || {});
  const dashboardData = successData?.data || {};
  useEffect(() => {
    dispatch(prDashboardAction());
  }, [dispatch]);

  const orderStatus = [
    {
      label: "Pending",
      value: dashboardData.pending,
      icon: <PendingIcon sx={{ p: 2, bgcolor: "rgba(231, 237, 255, 1)", borderRadius: "50%" }} />,
      bgColor: "rgba(219, 225, 240, 1)",
      textColor: "rgba(57, 106, 255, 1)"
    },
    {
      label: "Progress",
      value: dashboardData.progress,
      icon: <AccessTime sx={{ p: 2, bgcolor: " rgba(255, 245, 217, 1)", borderRadius: "50%" }} />,
      bgColor: "rgba(255, 224, 224, 1)",
      textColor: "rgba(255, 187, 56, 1)"
    },
    {
      label: "Manufactured",
      value: dashboardData.manufactured,
      icon: <FactoryIcon sx={{ p: 2, bgcolor: " rgba(250, 255, 231, 1)", borderRadius: "50%" }} />,
      bgColor: "rgba(234, 234, 234, 1)",
      textColor: "rgba(255, 167, 177, 1)"
    },
    {
      label: "Tested",
      value: dashboardData.tested,
      icon: <AssignmentTurnedInIcon sx={{ p: 2, bgcolor: "rgba(182, 140, 199, 1)", borderRadius: "50%" }} />,
      bgColor: "#EDE7F6",
      textColor: "rgba(144, 81, 244, 1)"
    },
    {
      label: "Delivered",
      value: dashboardData.delivered,
      icon: <CheckCircle sx={{ p: 2, bgcolor: "#E8F5E9", borderRadius: "50%" }} />,
      bgColor: "rgba(203, 255, 215, 1)",
      textColor: "#388E3C"
    },
  ];

  return (
    <Box
      sx={{
        ml: { xs: 2, sm: 5, md: 40, lg: 35 },
        mr: { xs: 2, sm: 5, md: 10, lg: 2 },
        mt: { xs: 10, sm: 18, md: 15 },
        mb: { xs: 2, sm: 4 },
      }}
    >
      <Box>
        <h1 style={{ fontWeight: "bold", fontSize: "2rem", fontFamily: "Poppins" }}>
          Production Dashboard
        </h1>
      </Box>
      <Typography
        variant="h5"
        fontWeight="bold"
        color="text.primary"
        gutterBottom
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.4rem", md: "1.5rem" },
          textAlign: { xs: "right", sm: "right", md: "right" },
          mt: 2,
        }}
      >
        Total Orders: {dashboardData.total_orders}
      </Typography>
      <Grid container spacing={2}>
        {orderStatus.map((status, index) => (
          <Grid item key={index} xs={12} sm={6} md={4} lg={2.4}>
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: { xs: 1, sm: 2 },
                borderRadius: 2,
                bgcolor: status.bgColor,
                boxShadow: 2,
                flexDirection: { xs: "column", sm: "row" },
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              <Box sx={{ color: status.textColor, fontSize: 30 }}>{status.icon}</Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ color: status.textColor, fontWeight: "medium" }}
                >
                  {status.label}
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {status.value}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProductionDashboard;
